import { defineSetting } from './settingsRegistry';

declare module './settingsRegistry' {
  interface Settings {
    /** Master volume 0–1, music volume 0–1, and mute. */
    volume: number;
    music: number;
    muted: boolean;
  }
}

// The two volumes are sliders, laid out by hand at the top of the menu's sound section.
defineSetting({ key: 'volume', default: 0.8, order: 10, range: [0, 1] });
defineSetting({ key: 'music', default: 0.5, order: 20, range: [0, 1] });
defineSetting({ key: 'muted', default: false, order: 30, menu: { group: 'sound', label: 'ปิดเสียง' } });
